/**************************************************
 * Nombre:       Dialogo_Soporte
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Grid} from "@mui/material";
import {useFormulario} from "../../Modulo_formularios/Hooks/useFormulario";
import {Outbox} from '@mui/icons-material'
import {useCargador} from "../../Modulo_Cargador/Hooks/useCargador";
import logo from '../../Recursos/logo_redondo.svg'
import {useContext, useEffect, useState} from "react";
import {usuarioContext} from "../../App";
import {guardarDoc} from "../../Servicios/BD/guardarDoc";
import {subirImagenHostingFile} from "../../Servicios/AlmacenamientoHosting/subirImagenHostingFile";
import Formulario_Perfil from "../Formularios/Formulario_Perfil";

const Dialogo_Perfil = ({cerrar, realizado, datos}) => {
    const cData = useContext(usuarioContext)
    const [cargando, setCargando] = useState(false)
    const {props, obtenerEntidad, setEntidad} = useFormulario({valoresDefecto: {}})
    const {Cargador, Avisos, iniciarCarga, nuevoAviso, terminar} = useCargador({
        logoRedondo: logo,
        funcionUno: cerrar,
        funcionDos: realizado
    })


    const enviarDatos = async () => {

        let entidad = await obtenerEntidad()

        iniciarCarga('Actualizando datos')
    setCargando(true)

        let imgDox = await subirImagenHostingFile(entidad.img)
        entidad.img = imgDox.data


        let dox = await guardarDoc('cuentas', entidad)
        if (dox.res) {
            cData.setUsuario(entidad)
            terminar({aviso: 'Cambios realizados con exito'})


        } else {
            terminar({aviso: 'Algo inesperado paso, porfavor intentalo nuevamente', variante: 'error'})
        }

        setCargando(false)

    }

    useEffect(() => {

        setEntidad(cData.usuario)


    }, [datos]);
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            spacing={2}
        >

            <Cargador/>

            <Avisos/>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                <Formulario_Perfil props={props}/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mb: 2}}>
                <Button
                    loading={cargando}
                    onClick={() => enviarDatos()}
                    startIcon={<Outbox/>}>Guardar Cambios</Button>
            </Grid>


        </Grid>
    )

}
export default Dialogo_Perfil